import React from "react";
import { ContextPage } from "./constants";
import { useImpressionTracking } from "./hooks/useImpressionTracking";

export const ImpressionTracker = ({
  publicationId,
  establishmentId,
  page = ContextPage.TRIPS_LIST,
  children,
}) => {
  const { ref } = useImpressionTracking({
    publicationId,
    establishmentId,
    page,
  });

  return <div ref={ref}>{children}</div>;
};
